import {Component, Input, OnInit} from '@angular/core';
import {ComponentHelper, FormBaseComponent, ValidatorService} from '@utils-lib';
import {AppNameEnum, TaetigkeitBeginnAngabe} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Component({
    selector: 'common-ui-beginn-taetigkeit-angaben',
    templateUrl: './beginn-taetigkeit-angaben.component.html',
    styleUrls: ['./beginn-taetigkeit-angaben.component.scss']
})
export class BeginnTaetigkeitAngabenComponent extends FormBaseComponent<TaetigkeitBeginnAngabe> implements OnInit {

    @Input()
    public beginnDerTaetigkeitStammdaten: string;
    public isKapGAus = false;

    constructor(private readonly formBuilder: FormBuilder,
                private readonly validatorService: ValidatorService,
                protected readonly messageService: DatevMessageService,
                protected readonly activatedRoute: ActivatedRoute) {
        super(messageService);
    }


    public ngOnInit(): void {
        super.ngOnInit();

        const appEnum = ComponentHelper.getAppEnum(this.activatedRoute.snapshot);
        if (appEnum === AppNameEnum.FragebogenKapGAus) {
            this.isKapGAus = true;
        }
    }

    protected createForm(): void {
        this.form = this.formBuilder.group({
            beginnDerTaetigkeit: [
                this.data?.beginnDerTaetigkeit, [
                    this.validatorService.date(),
                    this.validatorService.required()
                ]],
            endDerTaetigkeit: [
                this.data?.endDerTaetigkeit, [
                    this.validatorService.date(),
                    this.validatorService.required()
                ]],
            offenTaetigkeit: {value: this.data?.offenTaetigkeit, disabled: this.readonly}
        });
    }

}
